import React from "react";
import InfoPanel from "../components/RightPannel";
import ResendOtp from "./LeftPannel";
const ResendOtpComponent = () => {
  return (
    <InfoPanel parent="resend">
      <ResendOtp />
    </InfoPanel>
  );
};

export default ResendOtpComponent;
